module.exports = __webpack_public_path__ + "static/media/startPathFinding.c3588e01.gif";